import styled, { css } from 'styled-components'

import {
    RowFlex,
    ColumnFlex,
    AbsolutePositioning,
} from 'components/common/genericStyles'
import { Color } from 'constants/color'

export const ListItem = {
    Area: styled.div`
        ${RowFlex}
        align-items: center;
        justify-content: space-between;
        height: 56px;
        border-radius: 8px;
        transition: 0.5s ease;
        ${props => props.isScreensharing && `background: #0898641a;`}

        &:hover {
            background: ${Color.unknownColor19};
        }

        span {
            cursor: default;
        }

        & > * {
            transition: 0.5s ease;
        }
    `,
    LeftSection: styled.div`
        ${RowFlex}
        align-items: center;
        width: 40%;
    `,
    RightSection: styled.div`
        width: 15%;
        ${RowFlex}
        align-items: center;

        justify-content: space-evenly;

        & > * {
            margin-left: 10px;
        }

        .divider {
            width: 0px;
            height: 27px;
            opacity: 0.3;
            border: 1px solid ${Color.white};
        }

        .oh-rrc-3dm-menu {
            z-index: 999;
        }

        .oh-rrc-3dm-icon {
            height: unset;
        }
    `,
}

export const AvatarWrapper = styled.div`
    width: 28px;
    height: 28px;
    position: relative;

    &:before {
        border-radius: 50%;
        content: '';
        ${AbsolutePositioning}
        ${props => {
            const { isActiveSpeaker, isScreensharing } = props

            let styles = ''

            styles = isActiveSpeaker
                ? `${styles}
                   transform: scale(1.3); 
                   border: 1px solid ${Color.unknownColor23};`
                : styles

            styles = isScreensharing
                ? ` ${styles}
                    background-image: url(/assets/revamp/screenshare-on.svg);
                    background-repeat: no-repeat;
                    background-position: center;
                    background-color: #0000089e;
                    transform: scale(1.04);`
                : styles

            return styles
        }}
    }
`
export const AVStatusIcon = styled.img`
    width: 22px;
    height: 22px;
    flex-basis: 20%;
    ${({ disabled = false }) =>
        disabled &&
        css`
            opacity: 0.5;
        `}
`

export const Menu = styled.div`
    ${ColumnFlex}
    justify-content: center;
    height: 150px;
    background: #36383c;

    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08),
        0px 4px 12px -4px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
`

export const Identity = styled.div`
    ${RowFlex}
    flex-basis: 80%;
    align-items: center;
    & > div {
        margin-right: 22px;
    }
`

export const Para = styled.p`
    &::first-letter {
        text-transform: uppercase;
    }
`
